import { createFileRoute } from '@tanstack/react-router';

import DataTransmissionPageContainer from '../../components/transmissions/DataTransmissionPageContainer';
import LoadingPage from '../../components/shared/page-components/LoadingPage';

export const Route = createFileRoute('/_authenticated/transmission')({
  pendingComponent: () => <LoadingPage loadingPage />,
  component: DataTransmissionPageContainer,
  staticData: {
    configPageId: 'data-transmission',
    meta: {
      title: 'Data Transmission | Ledgible',
    },
  },
});
